var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 38,
  viewBox: "0 0 38 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 0C8.507 0 0 8.507 0 19s8.507 19 19 19 19-8.507 19-19A19 19 0 0 0 19 0m0 37C9.059 37 1 28.941 1 19S9.059 1 19 1s18 8.059 18 18a18 18 0 0 1-18 18"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.69 21.76-4.67-6.03-1.58 1.22 6.19 8 8.93-10.66L25.02 13z"
}))));
export default SvgCheckThin;